import { render, staticRenderFns } from "./Meditation.vue?vue&type=template&id=70e8984c&scoped=true&lang=pug&"
import script from "./Meditation.vue?vue&type=script&lang=js&"
export * from "./Meditation.vue?vue&type=script&lang=js&"
import style0 from "./Meditation.vue?vue&type=style&index=0&id=70e8984c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e8984c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
